import React, { useState, useEffect } from 'react';
import { Modal } from 'junto-ui';
import {
  Title,
  Wrapper,
  ModalContainer,
  Ancora,
  ConditionDetails,
  ParticularDetails,
  GrayBorder,
  ButtonWrapper,
  MenuWrapper,
  ContentWrapper,
  MenuItemsWrapper,
  LinkImage,
  AlignItensParticular,
  Image,
  Tooltip,
  ContentContainer,
  ScrollbarParticularDetails
} from './styles';
import downloadIcon from '../../../../assets/images/download-clauses.svg';

const ClauseInformationModal = ({
  isOpen,
  closeModal,
  generalCondition,
  particularConditions,
  handleDownload,
  specialCondition
}) => {
  const [selectedOption, setSelectedOption] = useState('gerais');
  useEffect(() => {
    setSelectedOption('gerais');
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      closeModal={closeModal}
      onBackdropClick={closeModal}
      mobileFullScreen
    >
      <ModalContainer>
        <Wrapper>
          <ContentContainer>
            <MenuWrapper data-testid="clauses-menu-wrapper">
              <Title>Condições contratuais padronizadas</Title>
              <MenuItemsWrapper>
                <div>
                  <Ancora
                    onClick={() => setSelectedOption('gerais')}
                    style={
                      selectedOption === 'gerais' ? { color: '#9000ff' } : null
                    }
                  >
                    Condições Gerais
                  </Ancora>
                  {specialCondition && (
                    <Ancora
                      onClick={() => setSelectedOption('especiais')}
                      style={
                        selectedOption === 'especiais'
                          ? { color: '#9000ff' }
                          : null
                      }
                    >
                      Especiais
                    </Ancora>
                  )}
                  {particularConditions?.length > 0 && (
                    <Ancora
                      onClick={() => setSelectedOption('particulares')}
                      style={
                        selectedOption === 'particulares'
                          ? { color: '#9000ff' }
                          : null
                      }
                    >
                      Particulares
                    </Ancora>
                  )}
                </div>
              </MenuItemsWrapper>
            </MenuWrapper>
            <ContentWrapper>
              {selectedOption === 'gerais' && (
                <ConditionDetails
                  data-testid="gerais-description"
                  id="ancora1"
                  dangerouslySetInnerHTML={{
                    __html: generalCondition?.description
                  }}
                />
              )}
              {(selectedOption === 'especiais' ||
                selectedOption === 'personalizado') && (
                <ConditionDetails
                  id="ancora2"
                  dangerouslySetInnerHTML={{
                    __html: specialCondition?.description
                  }}
                />
              )}
              {selectedOption !== 'gerais' &&
                selectedOption !== 'especiais' &&
                selectedOption !== 'personalizado' && (
                  <ScrollbarParticularDetails>
                    {selectedOption === 'particulares' &&
                      particularConditions?.map(p => (
                        <div>
                          <AlignItensParticular>
                            <ParticularDetails
                              id="ancora3"
                              dangerouslySetInnerHTML={{
                                __html: p.title
                              }}
                            />

                            <LinkImage onClick={() => handleDownload(p)}>
                              <Image src={downloadIcon} alt="Download" />
                              <Tooltip color="#fff"> Baixar </Tooltip>
                            </LinkImage>
                          </AlignItensParticular>
                          <GrayBorder />
                        </div>
                      ))}
                  </ScrollbarParticularDetails>
                )}
            </ContentWrapper>
            {selectedOption !== 'particulares' && (
              <ButtonWrapper>
                <LinkImage
                  style={{
                    flexDirection: 'row',
                    width: '200px',
                    margin: '24px 0 0 0'
                  }}
                  onClick={() =>
                    handleDownload(
                      selectedOption === 'gerais'
                        ? generalCondition
                        : specialCondition
                    )
                  }
                >
                  <Image
                    style={{
                      padding: '0px',
                      margin: '0 12px 0 0',
                      width: '20px'
                    }}
                    src={downloadIcon}
                    alt="Download"
                  />
                  <span
                    style={{
                      color: '#9000ff',
                      alignSelf: 'center',
                      fontWeight: '600'
                    }}
                  >
                    Baixar Texto
                  </span>
                </LinkImage>
              </ButtonWrapper>
            )}
          </ContentContainer>
        </Wrapper>
      </ModalContainer>
    </Modal>
  );
};

export default ClauseInformationModal;
